import toArray from '../../../frontend/scripts/utils/to-array';
import {
  addClass,
  removeClass,
} from '../../../frontend/scripts/utils/dom-helpers';

export default () => {
  const ESC = 27;
  const triggerEl = document.querySelector('.js-nav-top-search-trigger');
  const containerEl = document.querySelector('.js-nav-top-search-container');
  const iconEl = document.querySelector('.js-nav-top-search-icon');

  if (!triggerEl || !containerEl || !iconEl) {
    return;
  }

  const inputEl = containerEl.querySelector('input');
  const hideables = toArray(
    document.querySelectorAll('.js-nav-top-search-hide')
  );

  iconEl.addEventListener('mousedown', event => {
    event.preventDefault();

    if (event.button !== 1 && event.button !== 0) {
      return;
    }

    const formEl = document.getElementById('primary-nav__search-form');
    if (formEl) {
      formEl.submit();
    }
  });

  triggerEl.addEventListener('click', event => {
    event.preventDefault();

    containerEl.classList.add('is-active');
    hideables.forEach(addClass('is-search-active'));
    inputEl.focus();
  });

  inputEl.addEventListener('blur', () => {
    containerEl.classList.remove('is-active');
    hideables.forEach(removeClass('is-search-active'));
  });

  inputEl.addEventListener('keydown', ({ keyCode }) => {
    if (keyCode === ESC) {
      inputEl.blur();
    }
  });
};
